import { Linkable } from '@/components/blocks/Linkable';
import {
	breadcrumbTrailContainerSX,
	breadcrumbTrailLinkableSX,
} from '@/components/content/BreadcrumbTrail/styles/container';
import { useBreadcrumbTrail } from '@/data/Content/BreadcrumbTrail';
import { ID } from '@/data/types/Basic';
import { Breadcrumbs, Skeleton, Typography } from '@mui/material';
import { FC } from 'react';

export const BreadcrumbTrail: FC<{ id: ID }> = () => {
	const { breadcrumb, uniqueId, isLoading } = useBreadcrumbTrail();
	const breadcrumbLength = breadcrumb?.length;

	return isLoading ? (
		<Breadcrumbs sx={breadcrumbTrailContainerSX}>
			<Skeleton variant="text">
				<Typography sx={breadcrumbTrailLinkableSX}>{'Sortiment'}</Typography>
			</Skeleton>
		</Breadcrumbs>
	) : breadcrumbLength ? (
		<Breadcrumbs sx={breadcrumbTrailContainerSX} aria-label={breadcrumb?.at(-1)?.label}>
			{breadcrumb.map(({ href, label }, index: number) => (
				<Linkable
					sx={breadcrumbTrailLinkableSX}
					key={`breadcrumb-${uniqueId}-${index}-${label}`}
					href={index < breadcrumbLength - 1 ? href : undefined}
					type={'link'}
					data-testid={`breadcrumb-${uniqueId}-${index}-${label}`}
					id={`breadcrumb-${uniqueId}-${index}-${label}`}
				>
					{`${label}`}
				</Linkable>
			))}
		</Breadcrumbs>
	) : null;
};
